module.exports = __webpack_public_path__ + "static/new_player-4bad987d3ac07f8a39f6c1dd4d1b5c09.png";